<template>
  <div class="row">
    <!-- 備考 -->
    <label class="name">備考</label>

    <div v-if="remarks" class="value">
      {{ remarksWithNewlines }}
    </div>
  </div>
</template>

<script>
export default {
  name: "BMyTicketRemarksDisp",
  props: {
    remarks: {
      type: String,
      required: true,
    },
  },
  computed: {
    remarksWithNewlines() {
      return this.remarks.replace(/\\n/g, "\n");
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  font-size: 14px;
}

.row label {
  width: 110px;
  color: #888888;
}

.row .value {
  width: calc(100% - 110px);
  font-weight: bold;
  color: black;
  white-space: pre-wrap;
}
</style>
